<template lang="pug">
  .component-reservation-flag
    .row
      .column
        span Flags
      .column.text-right
        span.fa.fa-plus(@click="addFlag = !addFlag")
    .row(v-if="addFlag")
      .column
        select(v-model="body.flag")
          option(value="TERMINATED_IN_FORBIDDEN") Terminated in forbidden
          option(value="TERMINATED_IN_UNDESIRABLE") Terminated in undesirable
          option(value="HOLD_BILLING") Hold billing
          option(value="SKIP_DEPOSIT") Skip deposit
          option(value="SKIP_BILLING") Skip billing
          option(value="START_ZONES_CONFIG") Start zone config
          option(value="END_ZONES_CONFIG") End zone config
          option(value="EXTRA_COMMON_COST") Extra common cost
          option(value="SKIP_GPS_CHECK") Skip GPS check on RT end
          option(value="FORCE_REFUEL_ACTION") Force refuel
        label Flag value
          input(type="text", v-model="body.value")
        ActionButton(:action="saveFlag") Save
    .flag(v-for="flag in reservation.flags")
      span {{flag.flag}}:
      .values {{flag.value}}&nbsp;
        ActionButton(:button="false", :action="editFlag", :value="flag")
          span.fa.fa-pencil &nbsp;
          template(slot="prompt")
            h2 Edit flag {{flag.flag}}
            label Flag value
            //input(type="checkbox", v-model="flag.value", v-if="flag.flag === 'TERMINATED_IN_UNDESIRABLE'|| flag.flag === 'TERMINATED_IN_FORBIDDEN' || flag.flag === 'SKIP_DEPOSIT' || flag.flag === 'HOLD_BILLING' ")
            //selectize-common-cost(v-else-if="flag.flag === 'EXTRA_COMMON_COST'", :selectedValue="flag.value.split(',')", :maxItems="null")
            input(type="text",  v-model="flag.value")
        ActionButton(:button="false", :confirm="true", :action="deleteFlag", :value="flag")
          span.fa.fa-times
</template>

<script>
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'
  import ActionButton from '../structure/ui/ActionButton'
  import SelectizeCommonCost from '../structure/ui/lists/selectize/SelectizeCommonCost'

  export default {
    name: 'ReservationFlag',
    components: {SelectizeCommonCost, ActionButton},
    data() {
      return {
        addFlag: false,
        body: {
          flag: null,
          value: null
        }
      }
    },
    methods: {
      deleteFlag(flag) {
        return KeplerBackofficeSdk.reservationFlags.select(flag).delete(() => {
          MaggieHelper.notification('Flag', 'Deleted')
        })
      },
      editFlag(val) {
        return KeplerBackofficeSdk.reservationFlags.select(val).edit({
          value: val.value
        }, () => {
          MaggieHelper.notification('Flag', 'Edited')
        })
      },
      saveFlag() {
        return KeplerBackofficeSdk.reservationFlags.make(this.reservation.id, this.body, () => {
          MaggieHelper.notification('Flag', 'Added')
        })
      }
    },
    props: ['reservation']
  }
</script>

<style lang="sass">
  .component-reservation-flag
    .fa-plus
      color: #5EB9CF

    .flag
      display: flex
      justify-content: space-between

      .values
        display: flex

        .fa-times
          color: red

        .fa-pencil
          color: #5EB9CF


</style>



// WEBPACK FOOTER //
// ReservationFlag.vue?7090624a